import { render, staticRenderFns } from "./BoardCardDetail.vue?vue&type=template&id=2103130a&scoped=true&"
import script from "./BoardCardDetail.vue?vue&type=script&lang=js&"
export * from "./BoardCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./BoardCardDetail.vue?vue&type=style&index=0&id=2103130a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103130a",
  null
  
)

export default component.exports